var _style, _path, _path2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.3,9.1c0,0.7-0.3,1.2-0.9,1.6c-0.4,0.2-0.9,0.3-1.3,0.3c-1.6,0-3.2,0-4.8,0c-1.1-0.1-1.8-0.9-1.8-2 c0-0.6,0-1.3,0-1.9c0-0.3,0-0.7,0.1-1C3.8,5.8,4,5.4,4.3,5.2C4.6,5,4.9,4.9,5.2,4.9c0,0,0,0,0.1,0c0.3,0,0.6,0,0.9,0 c0.7,0,1.3,0,2,0c0.7,0,1.4,0,2.2,0c0.5,0,1,0.1,1.3,0.5c0.5,0.4,0.7,0.9,0.7,1.5C12.3,7.6,12.3,8.4,12.3,9.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.6,8c0-0.4,0-0.7,0-1.1c0-0.3,0.2-0.4,0.5-0.3C7.4,6.8,7.7,7,8,7.1c0.4,0.2,0.9,0.5,1.3,0.7 c0,0,0.1,0,0.1,0.1c0.2,0.1,0.2,0.2,0,0.3C8.7,8.6,7.9,9,7.1,9.3c-0.1,0-0.2,0.1-0.3,0c-0.2,0-0.2-0.1-0.2-0.3 C6.6,8.7,6.6,8.4,6.6,8z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 8,
    cy: 8,
    rx: 7.4,
    ry: 7.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialYoutube);
export default __webpack_public_path__ + "static/media/social-youtube.826fa102726253b139ac72688c8197a2.svg";
export { ForwardRef as ReactComponent };